import { defineStore } from "pinia";
import { SearchService } from "../services/search.service";
import { useFilterStore } from "./FilterStore";
import { useImageStore } from "./ImageStore";

const searchService = new SearchService();

const transformCountriesToIds = (company) => {
  return {
    ...company,
    countries: company.countries.map(country => country.country_id)
  };
}

let previousSearchValue = null;
let previousPage = null;
const isSearchValuesEqual = (a, b) => {
  if (!a || !b) {
    return false;
  }

  const isTagsEqual = a.tags.length === b.tags.length && a.tags.every((tag, index) => tag.id === b.tags[index].id);
  const isCategoryEqual = a.category?.id === b.category?.id;
  const isVendorEqual = a.vendor?.id === b.vendor?.id;
  const isColorEqual = a.color?.id === b.color?.id;
  const isOnlyNewProductEqual = a.onlyNewProduct === b.onlyNewProduct;
  const isTypeEqual = a.type?.id === b.type?.id;

  return isTagsEqual && isCategoryEqual && isVendorEqual && isColorEqual && isOnlyNewProductEqual && isTypeEqual;
}

export const useSearchStore = defineStore('search', {
  state: () => {
    return {
      page: 1,
      lastPage: undefined,
      isSearching: false,
      searchCount: 0,  // räknare för att se om nån sökning har gjorts
    }
  },

  getters: {
    numberOfImagesPerPage() {
      if (window.innerWidth < 600) {
        return 9;
      }
      if (window.innerWidth >= 600 && window.innerWidth < 960) {
        return 18;
      }
      if (window.innerWidth >= 960 && window.innerWidth < 1264) {
        return 24;
      }

      return 42;
    },
    isOnLastPage(state) {
      return state.page === state.lastPage
    },
    anySearchMade() {
      return this.searchCount > 1;
    }
  },

  actions: {
    isSearchChanged() {
      // If the search values are the same as the previous search, don't search again
      // This is to prevent unnecessary API calls when changing language
      const filterStore = useFilterStore();
      return !(isSearchValuesEqual(filterStore.all(), previousSearchValue) && this.page === previousPage)
    },
    async search(clearImageStore = false) {
      const filterStore = useFilterStore();
      const imageStore = useImageStore();

      this.isSearching = true;
      previousSearchValue = filterStore.all();
      previousPage = this.page;

      const response = await searchService
        .search(filterStore.all(), this.page, this.numberOfImagesPerPage)
        .finally(() => this.isSearching = false);

      this.$patch({
        searchCount: this.searchCount + 1,
        lastPage: response.meta.last_page
      })

      const tranformedData = response.data.map(image => ({ 
        ...image, 
        company: transformCountriesToIds(image.company)
      }));

      if (clearImageStore) {
        imageStore.set(tranformedData);
        return;
      }
      imageStore.append(tranformedData);
    },

    nextPage() {
      this.page++;
      this.search();
    },

    reset() {
      this.$patch({
        page: 1,
        lastPage: undefined,
        isSearching: false,
      });
    },
  }
});